import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import ShopHeader from '../../components/customer/ShopHeader';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const { t } = useTranslation();

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/shop');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);
    
    setLoading(false);

    if (result.success) {
      navigate('/shop');
    } else {
      setError(result.error);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--light)' }}>      
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-icon">🔐</div>
            <h1 className="auth-title">{t('login.title')}</h1>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-error">{error}</div>}
            
            <Input
              label={t('login.email')}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
              icon="✉️"
            />

            <Input
              label={t('login.password')}
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="********"
              required
              icon="🔒"
            />

            <div className="auth-options">
              <label className="remember-me">
                <input type="checkbox" />
                <span>{t('login.remember')}</span>
              </label>
            </div>

            <Button 
              type="submit" 
              variant="primary" 
              block 
              loading={loading}
            >
              {t('login.title')}
            </Button>
          </form>

          <div className="auth-footer">
            <p>{t('login.login')} <Link to="/register" className="auth-link">{t('login.loginLink')}</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;